<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# v-if="stage == stages.ENTRY"  -->

<template>
<div class="login login__body company-registration">
<div>
	<div class="mdc-layout-grid">
		<div class="mdc-layout-grid__inner center-horizontal mdc-theme--dark mdc-theme--text-primary-on-dark">


    <!-- COMPANY REGISTRATION -->
    <section class="section-companyNumber mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.COMPANY_NUMBER">
		 	<h1 class="login-title">Welcome to BestAgent, {{firstName}}</h1>
			<h3 class="login-title">Your account has been created, now please tell us your...</h3>
		  <h2 class="login-title">Company Name</h2>
        <div class="width-100 mdc-textfield mdc-textfield--upgraded company-registration__companies-house">
            <companies-house-input id="companies-house" title="Company name/number" @changed="companyData"></companies-house-input>
        </div>
		  <div class="width-100 mdc-textfield mdc-textfield--upgraded">
			   <input class="mdc-textfield__input" type="text" v-model="company.tradingName" placeholder="" />
			   <label class="mdc-textfield__label mdc-textfield__label--float-above">Trading or Sole Trader Name (if different)</label>
		  </div>
        <button class="mdc-button mdc-button--raised" ripple="!ripple" @click.prevent="goToBranchAddress()" :disabled="!company.registrationNumber && !company.tradingName">Next</button>
        <div class="btn-back">
            <a class="" @click.prevent="logout">Log out</a>
        </div>

    </section>

    <!-- CONFIRM ADDRESS -->
    <section class="section-showAddress mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage==stages.SHOW_ADDRESS">

		  <!-- <div class="width-100 mdc-textfield mdc-textfield--upgraded" v-if="showFlatNumberInput">
		  	 <input id="flatNumber02" class="mdc-textfield__input" type="text" v-model="company.address.flatNumber" :class="{'input--focus' : company.address.flatNumber !== ''}" placeholder="">
		  	 <label for="flatNumber02" class="mdc-textfield__label mdc-textfield__label--float-above">Enter number/letter if Flat</label>
		  </div>
		  <div class="width-100 mdc-textfield mdc-textfield--upgraded" v-if="showBuildingNumberInput">
		  	 <input id="streetNumber02" class="mdc-textfield__input" type="text" v-model="company.address.number" :class="{'input--focus' : company.address.number !== ''}" placeholder="">
		  	 <label for="streetNumber02" class="mdc-textfield__label mdc-textfield__label--float-above">Enter building number or name</label>
		  </div> -->

		  <div class="login__company-address">
			   <h4><strong>{{company.name}}</strong></h4>
				<span class="address-number" v-if="company.address.flatNumber != ''">{{company.address.flatNumber}}, </span>
				<span class="address-number" v-if="company.address.buildingNumber != ''">{{company.address.buildingNumber}} </span>
				<span class="address-street">{{company.address.street}}</span><br>
				<span class="street-town" v-if="company.address.town != ''">{{company.address.town}}, {{company.address.county}}<br></span>
				<span class="street-postcode">{{company.address.postcode}}</span>
		  </div>

		  <h2 class="login-title">Is this where your company is registered?</h2>

		<div class="">
		    <a href="" class="mdc-button mdc-button--stroked event-box__link-no" @click.prevent="changeStage(stages.ENTER_ADDRESS)">No</a>
			 <a href="" class="mdc-button mdc-button--raised event-box__link-yes" @click.prevent="stage = stages.BRANCH_ADDRESS; fillBranchAddress(company.address)">Yes</a>
		</div>

		<div class="btn-back">
			<a href="#" class="login__link" @click.prevent="stage = stages.COMPANY_NUMBER">&lt; back</a>
		</div>
    </section>

	 <!-- ENTER ADDRESS -->
	 <section class="section-googlePlaces mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage==stages.ENTER_ADDRESS">
	 	<address-stage v-on:googlePlacesUpdated="googlePlacesUpdated" v-model="company.branchAddress"
		:titleStage1="'Please type your company\'s address'" :titleStage2="'Confirm your company\'s address'"
		@next="changeStage(stages.BRANCH_ADDRESS); fillBranchAddress(company.address)"
		@back="changeStage(stages.SHOW_ADDRESS)"></address-stage>
 	 </section>


	 <!-- CONFIRM BRANCH ADDRESS -->
    <section class="section-branchAddress mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage==stages.BRANCH_ADDRESS">

		  <!-- <div class="width-100 mdc-textfield mdc-textfield--upgraded" v-if="showFlatNumberInput">
		    <input id="flatNumber02" class="mdc-textfield__input" type="text" v-model="company.branchAddress.flatNumber" :class="{'input--focus' : company.branchAddress.flatNumber !== ''}" placeholder="">
		    <label for="flatNumber02" class="mdc-textfield__label mdc-textfield__label--float-above">Enter number/letter if Flat</label>
		  </div>
		  <div class="width-100 mdc-textfield mdc-textfield--upgraded" v-if="showBuildingNumberInput">
		    <input id="streetNumber02" class="mdc-textfield__input" type="text" v-model="company.branchAddress.number" :class="{'input--focus' : company.branchAddress.number !== ''}" placeholder="">
		    <label for="streetNumber02" class="mdc-textfield__label mdc-textfield__label--float-above">Enter building number or name</label>
		  </div> -->

		  <div class="company-registration__address">
		  	 <span class="address-number" v-if="company.branchAddress.flatNumber != ''">{{company.branchAddress.flatNumber}}, </span>
		  	 <span class="address-number" v-if="company.branchAddress.buildingNumber != ''">{{company.branchAddress.buildingNumber}} </span>
		  	 <span class="address-street">{{company.branchAddress.street}}</span><br>
		  	 <span class="street-town" v-if="company.branchAddress.town != ''">{{company.branchAddress.town}}, {{company.branchAddress.county}}<br></span>
		  	 <span class="street-postcode">{{company.branchAddress.postcode}}</span>
		  </div>

		  <h2 class="login-title">Is this also your branch address?</h2>

         <div class="">
             <a href="" class="mdc-button mdc-button--stroked event-box__link-no" @click.prevent="fillBranchAddress({
					 number:  	'',
					 flatNumber:      	'',
					 street:          	'',
					 town:            	'',
					 county:          	'',
					 postcode:        	'',
					 lat:					'',
					 lng:					''
				 }); stage = stages.ENTER_BRANCH_ADDRESS">No</a>
				 <a href="" class="mdc-button mdc-button--raised event-box__link-yes" @click.prevent="changeStage(stages.SERVICE_TYPE)">Yes</a>
			</div>
        <div class="btn-back">
            <a href="#" class="login__link" @click.prevent="stage = stages.COMPANY_NUMBER">&lt; back</a>
        </div>
    </section>

	 <!-- ENTER BRANCH ADDRESS -->
	 <section class="section-manualAddress mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage==stages.ENTER_BRANCH_ADDRESS">
	   <address-stage v-on:googlePlacesUpdated="googlePlacesUpdated" v-model="company.branchAddress"
		:titleStage1="'Please type your branch address'" :titleStage2="'Confirm your branch address'"
		:buttonLabel="'Next'"
		@next="changeStage(stages.SERVICE_TYPE)" @back="changeStage(stages.BRANCH_ADDRESS)"></address-stage>
	 </section>

    <!-- COMPANY REGISTRATION -->
					<!-- Sales Status -->
	<section class="section-serviceType mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.SERVICE_TYPE">
		<div class="serviceType">
			<h2 class="service-type-title">What is the service type of your company?</h2>
			<button class="btn btn--bordered" :class="{'btn--selected': company.serviceType === 'Sales'}" v-on:click="company.serviceType = 'Sales'">Sales</button>
			<button class="btn btn--bordered" :class="{'btn--selected': company.serviceType === 'Lettings'}" v-on:click="company.serviceType = 'Lettings'">Lettings</button>
			<button class="btn btn--bordered" :class="{'btn--selected': company.serviceType === 'Both'}" v-on:click="company.serviceType = 'Both'">Both</button>
		</div>
		<button class="mdc-button mdc-button--raised" ripple="!ripple" @click.prevent="saveInfo()" :disabled="!company.serviceType">Save</button>
    </section>

	 </div>
	</div>
</div>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import GoogleMap            from '../components/GoogleMap.vue';
import CompaniesHouseInput  from '../components/CompaniesHouseInput.vue';
import AddressStage 			 from '../components/AddressStage.vue';
import { logout } from '@/libs/auth0';
import api from '@/libs/api.js';

export default {
    data: function() {
        return {
            stages: {
                COMPANY_NUMBER:     	0,
                SHOW_ADDRESS:       	1,
                ENTER_ADDRESS:     		2,
					 BRANCH_ADDRESS:			3,
					 ENTER_BRANCH_ADDRESS: 	4,
				SERVICE_TYPE: 5
            },

            stage: 0,

            company: {
							registrationName: '',
							registrationNumber: '',
							id:                 '',
							name:               '',
							tradingName: '',
							address: {
								number:          	'',
								flatNumber:      	'',
								street:          	'',
								town:            	'',
								county:          	'',
								postcode:        	'',
								lat:					'',
								lng:					''
							},
							branchAddress: {
								number:  	'',
								flatNumber:      	'',
								street:          	'',
								town:            	'',
								county:          	'',
								postcode:        	'',
								lat:					'',
								lng:					''
							},
							serviceType: ''
				},
				showFlatNumberInput: false,
				showBuildingNumberInput: false,
        }
    },
    //mixins: [utils],

    created: function() {

    },
    components: {
        'google-map':               GoogleMap,
        'companies-house-input':    CompaniesHouseInput,
		  'address-stage':				AddressStage
    },

    methods: {
        saveInfo: async function() {

			  var company = {
				  companyName: this.company.tradingName ? this.company.tradingName : this.company.name,
				  registrationName: this.company.name,
				  registrationNumber: this.company.registrationNumber,
				  registrationAddress: {
					  companyName: this.company.name,
					  buildingNumber:     this.company.address.buildingNumber,
                 flatNumber:         this.company.address.flatNumber,
                 street:             this.company.address.street,
                 town:               this.company.address.town,
                 county:             this.company.address.county,
                 postcode:           this.company.address.postcode
				  },
				  branchAddress: {
					  buildingNumber:     this.company.branchAddress.buildingNumber,
					  flatNumber:         this.company.branchAddress.flatNumber,
					  street:             this.company.branchAddress.street,
					  town:               this.company.branchAddress.town,
					  county:             this.company.branchAddress.county,
					  postcode:           this.company.branchAddress.postcode
				  },
				  serviceType: this.company.serviceType
			  }

			  try {
				 var result = await api({endpoint: this.config.services.companies, path: '/', method: 'POST', body: company});
				 this.$store.commit('setCompanyActive', true);
				 this.$store.commit('setCompanyName', this.company.name);
				 window.location = '/welcome';
			 } catch(err) {
				 throw {
					 type: 'company-setup-save',
					 error: err,
					 params: company
				 }
			 }

				// Update company
				/*
            this.$http.post(config.services.updateCompany, company)
                .then(function(response){
						 // Create branch
						 this.$http.post(config.services.createBranch, branch)
		                 .then(function(response){
								  // Go to start
		                     this.$router.push('/start');
		                 }, function(response) {
		                     console.error('Error saving branch:\n',
		                         branch, ': \n',
		                         'Response:\n', response);
		                     console.error('Response code:', response);
		                 })
                }, function(response) {
                    console.error('Error saving company:\n',
                        company, ': \n',
                        'Response:\n', response);
                    console.error('Response code:', response);
                })
					 */
        },

        googlePlacesUpdated: function(place) {
            if(place.street == '' || place.postcode == '') {
                return;
            }
				if(this.stage === this.stages.ENTER_ADDRESS){
	            this.company.address.buildingNumber =   place.buildingNumber;
	            this.company.address.street =   place.street;
	            this.company.address.postcode = place.postcode;
	            this.company.address.town =     place.town;
	            this.company.address.county =   place.county;
	            this.company.address.lat =      place.lat;
	            this.company.address.lng =      place.lng;

	            this.showFlatNumberInput = this.company.address.flatNumber == '';
	            this.showBuildingNumberInput = this.company.address.buildingNumber == '';
				} else {
					this.company.branchAddress.buildingNumber =   place.buildingNumber;
	            this.company.branchAddress.street =   place.street;
	            this.company.branchAddress.postcode = place.postcode;
	            this.company.branchAddress.town =     place.town;
	            this.company.branchAddress.county =   place.county;
	            this.company.branchAddress.lat =      place.lat;
	            this.company.branchAddress.lng =      place.lng;

	            this.showFlatNumberInput = this.company.branchAddress.flatNumber == '';
	            this.showBuildingNumberInput = this.company.branchAddress.buildingNumber == '';
				}
        },

        latLngGenerated: function(location) {
            this.company.address.lat = location.lat();
            this.company.address.lng = location.lng();
        },

        companyData: function(data) {
            this.company.name =                 data.title;
				if(this.company.tradingName == '') {
					this.company.tradingName = data.title.replace(/limited/ig, '').replace(/ltd/ig, '').replace(/llp/ig, '').trim();
				}
            this.company.registrationName =   data.title;
            this.company.registrationNumber =   data.company_number;
            this.company.address.street =               data.address.address_line_1;
            if (data.address.address_line_2) {
                this.company.address.street +=          ' ' + data.address.address_line_2;
            }
            this.company.address.buildingNumber =               data.address.premises;
            this.company.address.postcode =             data.address.postal_code;
            this.company.address.town =                 data.address.locality;

			if (data.address.region) {
				this.company.address.county =               data.address.region;
			}

			this.showFlatNumberInput = this.company.address.flatNumber == '';
			this.showBuildingNumberInput = this.company.address.buildingNumber == '';
        },

		  logout: function() {
			  logout();
		  },

		  changeStage: function(stage) {
			  this.stage = stage;
		  },

		  fillBranchAddress: function(address) {
			  this.company.branchAddress = address;
		  },

		  goToBranchAddress: function() {
			  if(this.company.registrationNumber) {
				  this.fillBranchAddress(this.company.address);
				  this.stage = this.stages.BRANCH_ADDRESS;
			  } else {
				  this.stage = this.stages.ENTER_BRANCH_ADDRESS
			  }
		  }

    },
    computed: {
		 branchAddressNotEmpty: function() {
			  return this.company.branchAddress.buildingNumber != '' && this.company.branchAddress.street != '' && this.company.branchAddress.postcode != '' && this.company.branchAddress.town != '' && this.company.branchAddress.county != '';
		 },
		 firstName() {
 			return this.$store.getters.fullname.split(' ')[0];
 		}
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/CompanySetup.vue